import { Container, Grid } from "@mui/material";
import ContactInfo from "./ContactInfo";
import ContactUs from "./ContactUs";

const Contact = () => {
  return (
    <Container disableGutters sx={styles.rootContainer}>
      <Container disableGutters sx={styles.contentContainer}>
        <Grid container>
          <Grid item xs={12} md={5} lg={5}>
            <ContactUs />
          </Grid>
          <Grid item xs={12} md={7} lg={7}>
            <ContactInfo />
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default Contact;

const styles = {
  rootContainer: {
    backgroundColor: "white",
    borderRadius: "20px",
  },
  contentContainer: {
    px: "4%",
    py: "4%",
  },
};
